<template>
  <div>
      <div v-if="redirectUrl">
        <div class="grid-x grid-padding-x align-center">
          <div class="cell text-center confirm">
              <i class="material-icons">check_circle</i>
              <h3>{{ $t('label.registrationCompleted') }}</h3>
              <p>
                {{ $t('label.loginAt') }}<br />
                <a v-bind:href="redirectUrl" class="link-underline">
                  {{redirectUrl}}
                </a>
              </p>
          </div>
        </div>
      </div>
      <div v-if="!redirectUrl && mail">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell">
                <h3>{{ $t('label.signUp') }}</h3>
                <h6 class="mail-to">Email: {{mail}}</h6>
            </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="cell small-12 text-right">
            <div class="loginOption">
              {{ $t('label.signUp') }}, {{ $t('label.lessThenMinute') }}
              <br />
              {{ $t('label.alreadyAccount') }}
              <router-link to="/">
                {{ $t('label.login') }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-9 small-12">
                <a v-bind:href="googleRedirect" class="abcRioButton abcRioButtonBlue"><div class="abcRioButtonContentWrapper"><div class="abcRioButtonIcon"><div class="abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg></div></div><span class="abcRioButtonContents"><span id="not_signed_injysz01as6q36">{{ $t('label.signupGoogle') }}</span></span></div></a>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-9 small-12 text-center">
                <div class="or-divider">
                  <span>
                    {{ $t('label.or') }}
                  </span>
                </div>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if="!apiFirstName">
            <div class="cell">
                <input type="text" required="true" v-bind:placeholder="$t('label.first_name')" v-model="first_name">
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center" v-if="!apiLastName">
            <div class="cell">
                <input type="text" required="true" v-bind:placeholder="$t('label.last_name')" v-model="last_name">
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center">
            <div class="cell">
                <input type="text" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.username')" v-model="username">
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center">
            <div class="cell">
                <input type="password" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.password')" v-model="password">
            </div>
        </div>
        <div class="grid-x grid-padding-x align-center">
            <div class="cell">
                <input type="password" required="true" autocorrect="off" autocapitalize="off" spellcheck="false" v-bind:placeholder="$t('label.confirmPassword')" v-model="password_confirm">
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if=organizationLegal.organization_consensi.data.field_label>
            <div class="cell small-12">
                <h6>{{organizationLegal.organization_consensi.data.field_label}}</h6>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if=organizationLegal.organization_consensi.data.description>
            <div class="cell small-12">
                {{organizationLegal.organization_consensi.data.description}}
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if=organizationLegal.organization_term_options.data.length>
            <div class="cell small-12">
                <ul>
                    <li v-for="option in organizationLegal.organization_term_options.data">
                        <input type="checkbox" v-model="option.active" :id="option.id">
                        <label :for="option.id">{{option.name}}</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center" v-if=organizationLegal.organization_consensi.data.field_legal>
            <div class="cell small-12">
                <div class="beebee-gdpr">
                    {{organizationLegal.organization_consensi.data.field_legal}}
                </div>
            </div>
        </div>

        <div class="grid-x grid-padding-x align-center align-middle">
            <div class="cell medium-3 small-3 text-center">
                <i class="material-icons beebee-gdpr-icon">verified_user</i>
            </div>
            <div class="cell medium-9 small-9">
                <div class="beebee-gdpr">
                  {{ $t('label.beebeeGDPR') }}
                  <a href="https://beebeeboard.com/normativa-privacy" target="_black">
                    {{ $t('label.privacyPolicy') }}
                  </a> e 
                  <a href="https://beebeeboard.com/termini-e-condizioni" target="_black">
                    {{ $t('label.termsOfServices') }}.
                  </a>
                </div>
            </div>
        </div>

        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <span class="messageError beebeeLabel">{{error}}</span>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell medium-6 small-12">
                <button class="button button-default expanded hovering ld-over" v-on:click="confirmR" v-bind:class="running ? 'running' : ''">
                  {{ $t('label.signUp') }}
                  <div class="ld ld-ball ld-flip"></div>
                </button>
            </div>
        </div>
      </div>

      <div v-if="invalid">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell text-center">
                <h5>{{ $t('label.invalidSession') }}</h5>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as CONFIG from '../config'

export default {
  name: 'confirm',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    first_name: null,
    last_name: null,
    username: null,
    password: null,
    password_confirm: null,
    apiFirstName: null,
    apiLastName: null,
    mail: null,
    error: '',
    redirectUrl: null,
    googleRedirect: null,
    invalid: false,
    running: false,
    organizationLegal: {
      organization_term_options: {
        data: []
      },
      organization_consensi: {
        data: {
          field_label: null,
          description: null,
          field_legal: null
        }
      }
    }
  }),
  created () {
    var self = this

    var token = this.token
    if (token) {
      this.googleRedirect = `${CONFIG.BASEURL}/api/auth/set_google?contact_id=${this.token}`

      axios.get(`${CONFIG.BASEURL}/api/v1/registration/confirm/${token}`)
      .then(res => {
        console.log(res)

        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.mail) {
          self.mail = res.data.data.user.mail
        }
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.first_name) {
          self.apiFirstName = res.data.data.user.first_name
        }
        if (res && res.data && res.data.data && res.data.data.user && res.data.data.user.last_name) {
          self.apiLastName = res.data.data.user.last_name
        }

        if (window.fcWidget) {
          window.fcWidget.on('widget:loaded', function (resp) {
            console.log('distruggo e ricarico widget')
            window.fcWidget.destroy()

            setTimeout(function () {
              console.log('window.fcWidget.init ' + res.data.data.user.organization + '-' + res.data.data.user.id)
              window.fcWidget.init({
                'token': '8cd4a741-d339-430f-91e9-075f0a56d52f',
                'host': 'https://wchat.freshchat.com',
                'siteId': res.data.data.user.organization,
                'externalId': res.data.data.user.organization + '-' + res.data.data.user.id,
                'restoreId': res.data.data.user.fresh_restore_id
              })
            }, 500)
          })
        }
      })
      .catch(function (reason) {
        self.invalid = true
      })

      axios.get(`${CONFIG.BASEURL}/api/v1/organizations/open`)
      .then(response => {
        if (response && response.data && response.data.data && response.data.data.relationships && response.data.data.relationships.gdpr) {
          if (!response.data.data.relationships.gdpr.organization_consensi.data) {
            response.data.data.relationships.gdpr.organization_consensi.data = {
              field_label: null,
              description: null,
              field_legal: null
            }
          }

          if (!response.data.data.relationships.gdpr.organization_term_options) {
            response.data.data.relationships.gdpr.organization_term_options = {data: []}
          } else if (!response.data.data.relationships.gdpr.organization_term_options.data) {
            response.data.data.relationships.gdpr.organization_term_options.data = []
          }

          if (!response.data.data.relationships.gdpr.organization_consensi) {
            response.data.data.relationships.gdpr.organization_consensi = {data: []}
          } else if (!response.data.data.relationships.gdpr.organization_consensi.data) {
            response.data.data.relationships.gdpr.organization_consensi.data = []
          }

          self.organizationLegal = response.data.data.relationships.gdpr
        }
      })
    }
  },
  methods: {

    confirmR () {
      var self = this
      var token = this.token

      if (this.running) {
        return false
      }

      if (!this.password || !this.password_confirm || !this.username || !(this.first_name || this.apiFirstName) || !(this.last_name || this.apiLastName)) {
        this.error = this.$t('label.emptyField')
        return false
      }

      var validateUsername = function (str) {
        return !/[^a-z0-9+.]/g.test(str)
      }

      var validateEmail = function (email) {
        var re = /\S+@\S+\.\S+/
        return re.test(email)
      }

      if (!validateEmail(this.mail)) {
        this.error = this.$t('label.invalidMail')
        return false
      }

      if (!validateUsername(this.username)) {
        this.error = this.$t('label.invalidUsername')
        return false
      }

      if (this.password !== this.password_confirm) {
        this.error = this.$t('label.passwordNotMatch')
        return false
      }

      this.error = ''
      self.running = true

      axios.put(`${CONFIG.BASEURL}/api/v1/registration/${token}`, {
        'data': {
          'attributes': {
            'first_name': this.apiFirstName ? this.apiFirstName : this.first_name,
            'last_name': this.apiLastName ? this.apiLastName : this.last_name,
            'password': this.password,
            'username': this.username,
            'gdpr': self.organizationLegal.organization_term_options.data
          }
        }
      }, {
        cache: false
      })
        .then(res => {
          self.running = false
          console.log(res)
          if (res && res.data && res.data.url && res.data.access_token) {
            self.$cookie.set('secure', res.data.access_token, {
              expires: parseFloat(res.data.access_token) / 60 / 60 / 24
            })

            if (window.fcWidget) {
              window.fcWidget.user.setProperties({
                'id': res.data.id,
                'firstName': res.data.first_name,
                'lastName': res.data.last_name,
                'email': res.data.mail,
                'Organization admin': res.data.organization_admin,
                'Organization name': res.data.organization,
                'Organization Product': res.data.redirect === 'clinic' ? 'Beebeehealth' : 'Beebeeboard',
                'Beebeeboard URI': `https://${res.data.organization}.beebeeboard.com`,
                'registrazione': 'Step 2: Dati completati'
              })

              window.fcWidget.track('registered-user')
            }

            self.redirectUrl = res.data.url
          }
        })
        .catch(function (reason) {
          self.running = false
          if (reason && reason.response && reason.response.data && reason.response.data.errors && reason.response.data.errors[0] && reason.response.data.errors[0].detail) {
            self.error = reason.response.data.errors[0].detail
          } else {
            self.error = self.$t('label.signupError')
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.mail-to {
  line-height: 50px; 
}

.loginOption {
  padding-top: 1rem;
  padding-bottom: 1.2rem;
  line-height: 1.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue